import { Link as ScrollLink } from "react-scroll";
import { useLocation, useNavigate } from "react-router-dom";
import { CONTENT } from "../constants/content";
import logo192 from "../assets/images/logo-192.webp";
import logo288 from "../assets/images/logo-288.webp";
import styles from "../styles/Footer.module.scss";

const FOOTER_LOGO_SRCSET = `${logo192} 192w, ${logo288} 288w`;

const Footer = () => {
  const { logoUrl, logoTitle, description, quickLinks, social, copyright } =
    CONTENT.footer;
  const SocialIcon = social?.icon;

  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brandColumn}>
          <div className={styles.logoLockup}>
            <img
              src={logoUrl}
              srcSet={FOOTER_LOGO_SRCSET}
              sizes="72px"
              className={styles.logoImage}
              width="609"
              height="621"
              loading="lazy"
              decoding="async"
              alt="MetodoAlps Logo"
            />
            <h2 className={styles.logoTitle}>{logoTitle}</h2>
          </div>

          <p className={styles.description}>{description}</p>

          {/* The one channel that matters, named rather than reduced to an
              anonymous glyph in a row of icons. */}
          {social && (
            <a
              className={styles.instagram}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.instagramMark} aria-hidden="true">
                {SocialIcon && <SocialIcon />}
              </span>
              <span className={styles.instagramText}>
                <span className={styles.instagramLabel}>{social.label}</span>
                <span className={styles.instagramHandle}>{social.handle}</span>
              </span>
            </a>
          )}
        </div>

        <nav className={styles.linksColumn} aria-label="Link utili">
          <h3>Link Utili</h3>
          <ul>
            {quickLinks.map((link) => (
              <li key={link.name}>
                {isHome ? (
                  <ScrollLink
                    to={link.to}
                    smooth={true}
                    duration={600}
                    offset={-72}
                    tabIndex={0}
                  >
                    {link.name}
                  </ScrollLink>
                ) : (
                  <button
                    type="button"
                    onClick={() =>
                      navigate("/", { state: { scrollTo: link.to } })
                    }
                  >
                    {link.name}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className={styles.bottomBar}>
        <p className={styles.copyright}>{copyright}</p>
      </div>
    </footer>
  );
};

export default Footer;
